import React from 'react'
import Nav from './Nav'
import Banner from './Banner'

export default function Home() {
    return (
        <div id='home'>
         <Nav/>
         <Banner/> 
         
        </div>
    )
}

